export default __webpack_public_path__ + "static/media/AlbertSans-Regular.2b5721dd.woff";